<template>
  <el-select
    class="w-100"
    v-model="value"
    :loading="loading"
    :placeholder="$t('common.select')"
    filterable
    size="small"
    clearable
    remote
    @change="change"
  >
    <el-option v-for="(item, index) in data" :key="index" :value="item.id" :label="item.name"/>
  </el-select>
</template>

<script>
import checklistService from '@/service/checklist'
import _find from 'lodash/find'

export default {
  props: {
    organization: ''
  },

  data () {
    return {
      value: '',
      loading: false,
      data: ''
    }
  },
  watch: {
    organization: function (newVal, oldVal) {
      this.fetchData()
    }
  },
  computed: {
    // data () {
    //   return this.$store.getters['Checklist/getListChecklist']
    // }
  },
  methods: {
    async fetchData () {
      this.loading = true
      const { data } = await checklistService.getListChecklist(1, 1000, '', '', '', this.organization.id).then(res => res.data)
      this.data = data
      this.loading = false
    },
    change () {
      this.$emit('input', this.value)
      const chk = _find(this.data, {'id': this.value})
      this.$emit('chk', chk)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/checklist/reports/ChecklistSelect.vue